// src/context/CartContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
const CartContext = createContext(null);

// Genera un key unico por producto + variaciones seleccionadas
const getItemKey = (producto) => {
  if (!producto.variaciones || producto.variaciones.length === 0) return producto.id;
  const varKey = producto.variaciones.map(v => v.tipo + ':' + v.valor).sort().join('|');
  return producto.id + '_' + varKey;
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('wawita_cart') || '[]'); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('wawita_cart', JSON.stringify(items));
  }, [items]);

  const agregar = (producto, cantidad = 1) => {
    const key = getItemKey(producto);
    setItems(prev => {
      const idx = prev.findIndex(i => i._key === key);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], cantidad: next[idx].cantidad + cantidad };
        return next;
      }
      return [...prev, { ...producto, cantidad, _key: key }];
    });
  };

  const quitar = (key) => setItems(prev => prev.filter(i => (i._key || i.id) !== key));

  const cambiarCantidad = (key, cantidad) => {
    if (cantidad <= 0) return quitar(key);
    setItems(prev => prev.map(i => (i._key || i.id) === key ? { ...i, cantidad } : i));
  };

  const vaciar = () => setItems([]);

  const total = items.reduce((s, i) => s + i.precio * i.cantidad, 0);
  const totalItems = items.reduce((s, i) => s + i.cantidad, 0);

  return (
    <CartContext.Provider value={{ items, agregar, quitar, cambiarCantidad, vaciar, total, totalItems }}>
      {children}
    </CartContext.Provider>
  );
}
export const useCart = () => useContext(CartContext);
